import { createFeatureSelector, createSelector } from '@ngrx/store';

import { signalrFeatureKey, SignalrState } from './signalr.reducer';

/**
 * Selects signalr state
 */
export const selectSignalrState = createFeatureSelector<SignalrState>(
  signalrFeatureKey,
);

/**
 * Selects signalr initialized
 */
export const selectIsSignalrInitialized = createSelector(
  selectSignalrState,
  (state) => state.initialized,
);
